import { useTranslate, useApiUrl, BaseKey } from "@refinedev/core";

import { Edit, useSelect } from "@refinedev/antd";

import {
    Drawer,
    DrawerProps,
    Form,
    FormProps,
    Input,
    InputNumber,
    Radio,
    Select,
    Space,
    ButtonProps,
    Avatar,
    Typography,
    Upload,
    Grid,
} from "antd";

const { Text } = Typography;

import { APP_WRITE_SPECIFICATION_ID } from "utility/constants";
import { SpecificationLabelSelectOptions } from "components/specificationLabelSelectOption";

type EditSpecificationProps = {
    drawerProps: DrawerProps;
    formProps: FormProps;
    saveButtonProps: ButtonProps;
    editId?: BaseKey;
};

export const EditSpecification: React.FC<EditSpecificationProps> = ({
    drawerProps,
    formProps,
    saveButtonProps,
    editId,
}) => {
    const t = useTranslate();
    const breakpoint = Grid.useBreakpoint();

    const {specificationLabelSelectProps} = SpecificationLabelSelectOptions();

    const handleOnFinish = (values : any) => {
        formProps.onFinish?.(
          {...values, Label: values.Label.$id}
        );
    }

    return (
      <Drawer
        {...drawerProps}
        width={breakpoint.sm ? "500px" : "100%"}
        zIndex={1001}
      >
        <Edit
          title={"Redigera Specifikation"}
          saveButtonProps={saveButtonProps}
          resource={APP_WRITE_SPECIFICATION_ID}
          recordItemId={editId}
          contentProps={{
            style: {
              boxShadow: "none",
            },
            bodyStyle: {
              padding: 0,
            },
          }}
        >
          <Form {...formProps} onFinish={handleOnFinish} layout="vertical">
            <Form.Item
              label="Typ"
              name={['Label', '$id']}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                placeholder="Välj typ"
                {...specificationLabelSelectProps}
              />
            </Form.Item>
            <Form.Item
              label="Värde"
              name="Value"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Artikelnummer"
              name="VariantId"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Edit>
      </Drawer>
    );
};
